const forms = {
    init() {
        //this.multipleSelect();
        this.customFileInputs();
    },
    customFileInputs() {
        $(document)
            .off('change.fileUpload')
            .on('change.fileUpload', '.js-file-upload input[type="file"]', function () {
                const input = this;
                const file = input.files && input.files[0];

                const $wrap = $(input).closest('.js-file-upload');
                const $name = $wrap.find('._file_upload_name');
                const $text = $wrap.find('._file_upload_text');
                const $icon = $wrap.find('._file_upload_icon i');

                const defaultText = $wrap.data('default-text') || $text.text();
                $wrap.data('default-text', defaultText);

                if (!file) {
                    $name.text('Aucun fichier sélectionné');
                    $text.text(defaultText);

                    $icon
                        .removeClass('fa-spinner fa-check fa-circle-check')
                        .addClass('fa-upload');

                    $wrap.removeClass('_loading _loaded _has_file _has_error');
                    return;
                }

                const maxSizeMo = parseFloat($wrap.data('max-size')) || 3;
                const maxBytes = maxSizeMo * 1024 * 1024;

                const allowedTypes = String($wrap.data('types') || '')
                    .split(',')
                    .map(type => type.trim())
                    .filter(Boolean);

                const isTypeOk = allowedTypes.length === 0 || allowedTypes.includes(file.type);

                if (!isTypeOk) {
                    alert($wrap.data('error-type') || 'Format non autorisé.');

                    input.value = '';
                    $name.text('Aucun fichier sélectionné');
                    $text.text(defaultText);

                    $icon
                        .removeClass('fa-spinner fa-check fa-circle-check')
                        .addClass('fa-upload');

                    $wrap.removeClass('_loading _loaded _has_file').addClass('_has_error');
                    return;
                }

                if (file.size > maxBytes) {
                    alert($wrap.data('error-size') || `Fichier trop lourd. ${maxSizeMo} Mo maximum.`);

                    input.value = '';
                    $name.text('Aucun fichier sélectionné');
                    $text.text(defaultText);

                    $icon
                        .removeClass('fa-spinner fa-check fa-circle-check')
                        .addClass('fa-upload');

                    $wrap.removeClass('_loading _loaded _has_file').addClass('_has_error');
                    return;
                }

                $wrap
                    .removeClass('_has_error _loaded _has_file')
                    .addClass('_loading');

                $text.text(file.name);
                $name.text('Chargement du fichier...');

                $icon
                    .removeClass('fa-upload fa-check fa-circle-check')
                    .addClass('fa-spinner');

                setTimeout(() => {
                    $wrap
                        .removeClass('_loading')
                        .addClass('_has_file _loaded');

                    $name.html(`
                    <span class="_success">
                        <i class="fa-solid fa-circle-check"></i>
                        Fichier chargé
                    </span>
                `);

                    $icon
                        .removeClass('fa-spinner fa-upload')
                        .addClass('fa-check');

                }, 600);
            });
    },
    multipleSelect() {

        $('.multiple-select').each(function () {
            const $select = $(this);

            // (éviter double init)
            if ($select.data('ms-initialized')) return;

            $select.multipleSelect({
                hideOptgroupCheckboxes: true,
                selectAll: false
            });

            // 2) UI compteur + tags pour CETTE instance
            const $parent = $select.next('.ms-parent');
            const $choiceSpan = $parent.find('.ms-choice > span');
            // conteneur des tags (un par select)
            let $tags = $parent.next('.ms-tags');
            if ($tags.length === 0) {
                $tags = $('<div class="ms-tags"></div>').insertAfter($parent);
            }

            function refreshUI() {
                const values = $select.multipleSelect('getSelects');        // ['1','3',...]
                const texts = $select.multipleSelect('getSelects', 'text'); // ['Chapeau','...']
                const n = values.length;

                // 2.1 Compteur dans le bouton
                const placeholder = $select.attr('data-placeholder') || 'Sélectionner';
                $choiceSpan.text(n === 0 ? placeholder : `${n} item${n > 1 ? 's' : ''}`);

                // 2.2 Tags sous le select
                $tags.empty();
                texts.forEach((label, i) => {
                    const val = values[i];
                    $tags.append(
                        $(
                            `<span class="ms-tag" data-value="${val}">
               ${label}
               <button type="button" class="ms-tag-x" aria-label="Retirer">×</button>
             </span>`
                        )
                    );
                });
            }

            // Clic sur la croix d’un tag => désélectionne dans le plugin
            $tags.on('click', '.ms-tag-x', function () {
                const val = String($(this).closest('.ms-tag').data('value'));
                const left = $select.multipleSelect('getSelects').filter(v => String(v) !== val);
                $select.multipleSelect('setSelects', left);
                refreshUI();
            });

            // Tout changement (clics dans le menu, select/deselect, etc.)
            $select.on('change', refreshUI);

            // 3) Premier rendu + marqueur pour éviter ré-init
            refreshUI();
            $select.data('ms-initialized', true);
        });

        $(document).on('click', '.ms-parent > .ms-choice', function () {
            const $drop = $(this).siblings('.ms-drop');

            if ($drop.length) {
                $drop
                    .attr('data-lenis-prevent-wheel', '')
                    .attr('data-lenis-prevent-touch', '');
            }
        });
    },

    selectAgenda() {
        // $('.multiple-select').multipleSelect({
        //     filter: false,                 // pas de champ de recherche
        //     selectAll: false,
        //     placeholder: 'Sélectionner'
        // });
    }

};

export default forms;
